import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Box } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend);

const PALETTE = ["#7F77DD", "#1D9E75", "#D85A30", "#D3D1C7", "#4b1f6b", "#b5790f"];

const StatusDonut = ({ labels, data: values }) => {
  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: labels.map((_, i) => PALETTE[i % PALETTE.length]),
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "68%",
    animation: { duration: 900, easing: "easeOutQuart" },
    plugins: {
      legend: {
        position: "bottom",
        labels: { boxWidth: 9, usePointStyle: true, padding: 14, font: { size: 11.5 } },
      },
    },
  };

  return (
    <Box sx={{ position: "relative", height: 190 }}>
      <Doughnut data={data} options={options} />
    </Box>
  );
};

export default StatusDonut;
